/**
 * This function will get ISO language code and return language code (used in navigation)
 * It trims everything after the dash (with the dash), for example: pt-pt becomes pt
 *
 * @param {string} isoLanguageCode
 * @returns {string}
 */
module.exports = (isoLanguageCode) => isoLanguageCode.replace(/-\w+/g, '');
